import { Box, Button, Skeleton, Typography } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import axios from 'axios';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import veg from "../Assets/product_management/Foodmark.svg"
import nonVeg from "../Assets/product_management/non-veg.svg"
import { updateAvailable, updateInventoryDetail, updateInventoryDetailsModal, updateInventryHubsupervisors, updateSelectedBatchNo, updateSelectedInventoryId, updateTotalOrdered, updateallInventryDetails, updateinventoryDetailsEdit } from "../Redux/inventory";
import { useState , useMemo} from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import Tooltip from '@mui/material/Tooltip';
import CustomAxios from "../utils/CustomAxios";
import { useDateformate, useGetBatchHistory, useGetInventoryDetails } from "../Components/globalFunctions";
import { useNavigate } from "react-router-dom";
import { updatepageName } from "../Redux/page";
export function InventoryBatchTable() {
    const toast = useRef(null);
    const dispatch = useDispatch();
    const user_id = useSelector( state => state.user.id)
    const batchHistory = useSelector(state => state.inventory.batchHistory)
    const dateFormat = useDateformate()
    const selectedInventoryId = useSelector(state => state.inventory.selectedInventoryId)
    const inventoryDetailsLoading = useSelector(state => state.inventory.inventoryDetailsLoading);
    const getBatchHistory = useGetBatchHistory()
    const [matchedProducts, setMatchedProducts] = useState([]);
    const selectedHubValue = useSelector(state => state.user.selected_hub);
    
    const user_role = localStorage.getItem('role');
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    const resolvedSelectedHub = useMemo(() => {
        const normalizeValue = (value) => {
            if (value === null || value === undefined) return null;
            if (Array.isArray(value)) {
                if (value.length === 0) return null;
                return normalizeValue(value[0]);
            }
            if (typeof value === 'string') {
                if (value.trim() === '' || value === 'null') return null;
                const parsed = Number(value);
                return Number.isNaN(parsed) ? value : parsed;
            }
            return value;
        };

        const direct = normalizeValue(selectedHubValue);
        if (direct !== null && direct !== undefined) return direct;

        const stored = localStorage.getItem('selected_hub');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                const normalized = normalizeValue(parsed);
                if (normalized !== null && normalized !== undefined) return normalized;
            } catch (error) {
                const normalized = normalizeValue(stored);
                if (normalized !== null && normalized !== undefined) return normalized;
            }
        }
        return null;
    }, [selectedHubValue]);

    const normalizedAssignedHubs = useMemo(() => {
        if (Array.isArray(assignedHubs)) {
            return assignedHubs
                .map((id) => Number(id))
                .filter((id) => !Number.isNaN(id));
        }
        const parsed = Number(assignedHubs);
        return Number.isNaN(parsed) ? [] : [parsed];
    }, [assignedHubs]);

    const hasHubAccess = useMemo(() => {
        if (!resolvedSelectedHub) return false;
        if (normalizedAssignedHubs.length === 0) return true;
        return normalizedAssignedHubs.includes(Number(resolvedSelectedHub));
    }, [resolvedSelectedHub, normalizedAssignedHubs]);

    const canEditBatch = () => {
        if (user_role === 'super_admin') return true; 
        if (user_role === 'admin') return hasHubAccess;
        if (user_role === 'supervisor') return hasHubAccess;
        return false;
    };

    const canDeleteBatch = () => {
        if (user_role === 'super_admin') return true;
        if (user_role === 'admin') return hasHubAccess;
        if (user_role === 'supervisor') return hasHubAccess;
        return false; 
    };

    useEffect(() => {
        getBatchHistory()
    }, [])

    const handleSearch = () => {
        const matches = batchHistory
            .flatMap((entry) => entry.batch
                .filter((product) => {
                    console.log("Comparing:", product.product, selectedInventoryId.product_id);
                    return product.product.id == Number(selectedInventoryId.product_id); // Ensure comparison is correct
                }).map((product) => ({
                    ...product,
                    purchased_on: entry.purchased_on,
                    batchno: entry.batch_number,
                }))
            );

            let total = 0
            let available = 0
            let units = ""
            console.log(matches,inventoryDetailsLoading,selectedInventoryId)
            matches.map((batch)=>{
                if (batch.units=="ml" || batch.units=='gms'){
                    console.log( batch.quantity,batch.available_units)
                    total +=parseFloat( batch.quantity)/1000
                    available += parseFloat(batch.available_units)/1000
                }
                else{
                    total += parseFloat(batch.quantity)
                    available += parseFloat(batch.available_units)
                }
                
                // units = batch.units
            })
            setMatchedProducts(matches);
        dispatch(updateTotalOrdered(parseFloat(total).toFixed(2)+" "+selectedInventoryId.units))
        dispatch(updateAvailable(parseFloat(available).toFixed(2)+" "+selectedInventoryId.units))
    };

    useEffect(() => {
        handleSearch();
    }, [batchHistory]);
      const confirmDelete = (item) => {
        console.log(item)
        confirmDialog({
          message: (
            <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                Do you want to delete this Batch detail
              </Typography>
            </Box>
          ),
          header: "Delete Confirmation",
          defaultFocus: 'reject',
          acceptClassName: 'p-button-danger',
          accept: () => accept(item),
        });
      };
    
      const accept = async (batch) => {
        try {
          await CustomAxios.delete(`inventory/details/delete/${batch.batch}/`,{data:{admin_id:user_id,batch_details_id:batch.id,batch_delete:false}})
          .then(() => {
            getBatchHistory()
            dispatch(updateSelectedBatchNo({}))
            toast.current.show({
                  severity: "success",
                  summary: "Success",
                  detail: "Batch details deleted successfully",
                  life: 3000,
                });
          })
                
        } catch (err) {
          console.error("Error deleting delivery details", err);
        }
      };

    const handleOpen = (row) => {
        const filtered = batchHistory.filter((batch)=>{
            console.log(batch.batch_number,row)
                return batch.batch_number === row.batchno
        })
        console.log(filtered[0])

        dispatch(updateinventoryDetailsEdit(true))
        dispatch(updateInventoryDetail(filtered[0]));
        dispatch(updateInventoryDetailsModal(true))
        
    };
    return (<Box>
        <Toast ref={toast} />
        {/* <ConfirmDialog/> */}
        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S no</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Batch</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Total Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Available Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Purchased on</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Expired</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Bogo Status</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {matchedProducts?.length > 0 ?
                        matchedProducts?.map((item, ind) => {
                            console.log(item)
                            return (<> {
                                <TableRow key={item.id}>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{ind + 1}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.batchno}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.quantity}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.available_units} {item.units}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{dateFormat(item.purchased_on)}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{dateFormat(item.expired_on)}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.bogo_enabled?"Active":"Inactive"}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white", display: "flex", gap: "8px" }}>
                                        {(() => {
                                              const allowEdit = canEditBatch();
                                              const allowDelete = canDeleteBatch();
                                              const message = (user_role === 'admin' || user_role === 'supervisor')
                                                  ? "You do not have access to manage batches for this hub"
                                                  : "No access";
  
                                                if (!allowEdit && !allowDelete) {
                                                    return (
                                                        <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "gray" }}>
                                                            {message}
                                                        </Typography>
                                                    );
                                                }
                                                return (
                                                    <>
                                                          {allowEdit && (
                                                        <Tooltip title="Update" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(item)}>
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    )}
                                                    {allowDelete && (
                                                        <Tooltip title="Delete" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}>
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    )}
                                                    </>
                                                );
                                        })()}
                                    </TableCell>
                                </TableRow>}</>)
                        })
                        : <TableRow  >
                                <TableCell  colSpan={8} sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }}>No Inventory Details Available</TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}